export type PartTone = 'blue' | 'green' | 'amber' | 'indigo' | 'rose' | 'teal' | 'purple';

export type PartIcon =
    | 'video-camera'
    | 'calendar-days'
    | 'clock'
    | 'clipboard-document-check'
    | 'chat-bubble-left-right'
    | 'squares-2x2'
    | 'shield-check'
    | 'signal'
    | 'bell-alert'
    | 'chart-bar';

export type PartTakeaways = readonly [string, string, string];

export interface VideoPart {
    part: number;
    title: string;
    duration: string;
    youtubeId: string;
    icon: PartIcon;
    tone: PartTone;
    takeaways: PartTakeaways;
}

export interface VideoReleaseWelcome {
    headline: string;
    subtitle: string;
}

export interface VideoRelease {
    name: string;
    finalLabel: string;
    welcome: VideoReleaseWelcome;
    parts: VideoPart[];
}

export interface VideoReleaseEntry {
    version: string;
    date: string;
    release: VideoRelease;
}

export function youTubeNoCookieEmbedUrl(youtubeId: string): string {
    return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}`;
}
